import { Injectable } from '@angular/core';
import { LINKTYPES } from '../app/app-model/enums';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class RoutingEventService {
  constructor(public router: Router) { }

  goto(type: LINKTYPES) {
    // Switch on each case and route
    switch (type) {
      case LINKTYPES.LOGIN:
      case LINKTYPES.HOMEPAGE:
        this.router.navigateByUrl('/login');
        return;

      case LINKTYPES.DASHBOARD:
        this.router.navigateByUrl('/dashboard');
        return;

      case LINKTYPES.HOME_REPORT_DASHBOARD_MANAGEMENT:
        this.router.navigateByUrl('/dashboard/home');
        return;

      case LINKTYPES.ID_CARD_MANAGEMENT:
        this.router.navigateByUrl('/dashboard/id-management');
        return;

      case LINKTYPES.GENERATED_ID_CARD_MANAGEMENT:
        this.router.navigateByUrl('/dashboard/bulk-id-download');
        return;

      case LINKTYPES.PROJECT_MANAGEMENT:
        this.router.navigateByUrl('/dashboard/project-management');
        return;

      case LINKTYPES.USER_MANAGEMENT:
        this.router.navigateByUrl('/dashboard/user-management');
        return;

      default:
        return;
    }
  }
}
